export default "__VITE_ASSET__bHG_BMmH__"